export const SET_LANG = 'SET_LANG'
export const SET_PROFILE = 'SET_PROFILE'
export const SET_COUNTRY = 'SET_COUNTRY'
/* 购物车相关 */
export const ADD_TO_CART = 'ADD_TO_CART'
export const SET_QUANTITY = 'SET_QUANTITY'
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART'
export const CLEAR_CART = 'CLEAR_CART'
export const SET_CART = 'SET_CART'